module.exports = {
	"INLINE": "Testesssss",
	"nav_home": "Begin",
	"nav_menu": "Menu",
	"nav_about": "Restaurant",
	"nav_wines": "Wijn",
	"nav_suggestions": "Suggesties",
	"nav_events": "Evenementen",
	"nav-feedback": "Jouw mening",
	"follow_text": "Volg ons",
	"desktop_languages": "Talen",
	"intro_default_option": "Filter menu op:",
	"suggested_extras": "Voorgestelde bijgerechten",
	"suggested_wines": "Voorgestelde wijnen",
	"cta_title": "Zie onze selectie van ",
	"cta_btn": "Zien",
	"related_products": "Vergelijkbare producten",
	"error_home_link": "Terug naar start",
	"error_home_title1": "Hmm...",
	"error_home_title2": "De pagina die u zoekt, is niet gevonden.",
	"error_home_text": "Probeer het adres te herschrijven of probeer het later opnieuw.",
	"detail_title": "In detail",
	"list_event_title": "Evenementen",
	"event_link": "Officiële Pagina",
	"other_events": "Andere evenementen",
	"filters": "Filters",
	"filter-group-region-type": "Type wijn en regio",
	"region_default_option": "Kies een regio",
	"filter-group-type": "Type",
	"type_default_option": "Kies een type",
	"filter-group-flavour": "Smaak",
	"filter-group-characteristics": "Wijnkenmerken",
	"sweetness_default_option": "Zuurgraad",
	"filter-group-body": "Lichaam",
	"body_default_option": "Kies het lichaam",
	"filter-group-ingredients": "Hoofdingrediënten",
	"filter-group-diets": "Intoleranties",
	"filter-results": "{results} resultaten",
	"filter-clear-button": "Filters wissen",
	"filter-apply-button": "Toepassen",
	"related_dishes": "Voorgestelde gerechten",
	"empty-title": "Geen resultaten",
	"empty-text": "We hebben momenteel geen resultaten om weer te geven. Probeer het opnieuw met nieuwe parameters.",
	"feedback-title": "Help ons verbeteren",
	"feedback-intro": "Laat ons uw kritiek en meningen achter, zodat we Pickly voor u kunnen verbeteren.",
	"feedback-improve": "Heeft Pickly uw restaurantervaring verbeterd?",
	"feedback-error": "Kies een optie alstublieft",
	"feedback-harder": "Ingewikkeld",
	"feedback-no-help": "Heeft niet geholpen",
	"feedback-indiferent": "Onverschillig",
	"feedback-helped": "Hielp",
	"feedback-helped-a-lot": "Veel geholpen",
	"feedback-recommend": "Zou je andere restaurants aanbevelen om Pickly te gebruiken?",
	"feedback-no-recommend": "Ik raad het niet aan",
	"feedback-recommend-neutral": "Onverschillig",
	"feedback-recommend-yes": "ik raad aan",
	"feedback-msg": "Laat ons uw mening achter over uw ervaring en hoe u denkt dat we de applicatie kunnen verbeteren. (optioneel)",
	"feedback-submit": "Verzenden",
	"feedback-thanks-title": "Dank u",
	"feedback-thanks-text": "Bedankt voor je hulp bij het verbeteren! Via onderstaande knop kunt u terugkeren naar het begin.",
	"restaurant-feedback-title": "Jouw mening is belangrijk.",
	"restaurant-feedback-subtitle": "Help ons verbeteren.",
	"restaurant-feedback-intro": "Vertel ons over uw ervaringen in ons restaurant en evalueer de service, het eten en het milieu door middel van een korte vragenlijst.",
	"restaurant-feedback-intro-btn": "Geef feedback",
	"food-feedback-title": "Beoordeling van voedsel",
	"food-feedback-intro": "Geef uw mening en help ons verbeteren.",
	"choice-question": "Het menu had een goede selectie aan gerechten",
	"presentation-question": "Os pratos tinham uma boa apresentação",
	"tasty-question": "De gerechten hadden een goede presentatie",
	"service-feedback-title": "SERVICE Evaluatie",
	"speed-question": "Ze behandelden ons verzoek snel",
	"waiters-question": "De medewerkers waren vriendelijk en attent",
	"overall-question": "Over het algemeen was de service goed",
	"global-feedback-title": "GLOBALE Evaluatie",
	"deco-question": "Het restaurant had een goede sfeer en inrichting",
	"price-question": "De prijs / kwaliteitverhouding was goed",
	"recommend-question": "Zou het restaurant aanbevelen aan een vriend",
	"comments-question": "Commentaar en suggesties",
	"recommend_title": "Zou je dit gerecht aanbevelen?",
	"recommend-total": "{total} klanten bevelen dit gerecht aan.",
	"type": "type",
	"body": "lichaam",
	"region": "regio",
	"accidity": "zuurgraad",
	"mypick-text": "Met myPick selecteer je jouw favoriete gerechten, drankjes en desserts voor deze maaltijd. Vraag het dan aan de ober.",
	"cookie-notice": "Door deze site te gebruiken, gaat u akkoord met het gebruik van cookies voor analyse en statistieken.",
	"terms-title": "Voorwaarden",
	"price_under_request": "Prijs op aanvraag"
};


/*****************
 ** WEBPACK FOOTER
 ** ./locales/nl-nl.json
 ** module id = 278
 ** module chunks = 0
 **/